<template>
    <div>
      <div class="bgc_white">
        <NavbarHeader activeName="joinus"></NavbarHeader>
        <div v-if="bannerList.length>0" style="background-color: #F5F5F5;">
          <swiperList v-if="bannerList.length>0" :bannerList="bannerList"></swiperList>
        </div>
        <div class="recommend_section" id="targetbox">
          <div :style="[{display: showMoudel==0?'block':'none'}]">
            <workList v-if="refreshwork" @watchInfo="watchInfo" :pageTop="pageTop"
             @deliverylistJob="deliverylistJob" :windowWidth="windowWidth"></workList>
           </div>
          <workInfo v-if="showMoudel==1" :jobInfo="jobInfo" @deliveryJob="deliveryJob"
		   :windowWidth="windowWidth" @backJob="backJoblist" :backValue="backValue"></workInfo>
          <workApply v-else-if="showMoudel==2" :jobInfo="jobInfo" :backValue="backValue" @backJob="backJob" :windowWidth="windowWidth"></workApply>
        </div>

        <footerBar></footerBar>
      </div>
    </div>
</template>
<script>
	import { basebannerListapi} from "@/api/apilist/commonApi";
  import workApply from "./components/assembly/workApply.vue";
  import workInfo from "./components/assembly/workInfo.vue";
  import workList from "./components/assembly/workList.vue";
  import swiperList from "@/components/assembly/swiperList.vue";
  import footerBar from "@/components/footerBar/footerBar.vue";
  import NavbarHeader from "@/components/NavbarHeader/NavbarHeader.vue";
  export default {
      components: {
        NavbarHeader, footerBar, swiperList, workList, workInfo, workApply
      },
      data() {
        return {
          bathUrl: 'https://mall.alicdn.girdeargroup.com/admin/pms/media/images/',
          bannerList: [],
          showMoudel: 0,
          jobInfo: {},
          backValue: 0,
          windowWidth: 1200,
          pageTop: false,
          refreshwork: true
        };
      },

      created() {
		this.getbasebannerList();
      },
	  mounted(){
	    this.windowWidth = document.documentElement.clientWidth;
	    window.addEventListener('resize', () => { //监听浏览器窗口大小改变
			//浏览器变化执行动作
	      this.windowWidth = window.innerWidth;
	    });
	  },
      methods:{
		  deliveryJob(){
        // document.documentElement.scrollTop = 0;
			  this.backValue = 1;
			  this.showMoudel = 2;
		  },
		  deliverylistJob(row){
        // document.documentElement.scrollTop = 0;
        this.jobInfo = row;
			  this.backValue = 0;
		  	this.showMoudel = 2;
		  },
		  watchInfo(row){
        // document.documentElement.scrollTop = 0;
        this.$nextTick(() => {
          setTimeout(() => {
            let targetbox = document.getElementById('targetbox');
            document.documentElement.scrollTop = targetbox.offsetTop;
          },100)
        })
			  this.jobInfo = row;
			  this.showMoudel = 1;
		  },
      backJoblist(){
        // document.documentElement.scrollTop = 0;
        this.backValue = 0;
			  this.showMoudel = 0;//根据这个判断返回哪里
		  },
		  backJob(val, val2){
        if(val2){
          this.pageTop = true;
          this.refreshwork = false;
          setTimeout(()=>{
            this.refreshwork = true;
          },100)
        }
        // document.documentElement.scrollTop = 0;
        this.backValue = val;
			  this.showMoudel = val;//根据这个判断返回哪里
        console.log('this.pageTop', this.pageTop, val)

		  },
		getbasebannerList() {
			basebannerListapi({ bannerType: 5 }).then(res=>{
				this.bannerList = res.data;
			})
		},
      }
  }
</script>

<style scoped lang="less">
	.recommend_section{
		background-color: #fff;
	}

	@media screen and (max-width: 480px){
		.recommend_section{
			padding: 0 15px;
		}
	}
	@media screen and (min-width: 481px){
		.recommend_section{
			width: 1200px;
			margin: 0 auto;
		}
	}
</style>
